// Единый формат чисел админки: разряды через неразрывный пробел (1 000, 10 000), дробь через запятую.
// Неразрывный пробел (Intl для ru-RU) не даёт числу разорваться на две строки в узкой ячейке.

const intFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
const moneyFmt = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

function toNumber(v) {
    if (v === null || v === undefined || v === '') return null;
    const n = typeof v === 'number' ? v : Number(String(v).replace(/\s/g, '').replace(',', '.'));
    return Number.isFinite(n) ? n : null;
}

// Количества: 12 840. Нечисловое значение возвращается как есть, пустое — «—».
export function fmtInt(v) {
    const n = toNumber(v);
    if (n === null) return v === null || v === undefined || v === '' ? '—' : v;
    return intFmt.format(n);
}

// Деньги и цены: 48 250,50 · 0,0125 (тарифы бывают с 4 знаками)
export function fmtMoney(v) {
    const n = toNumber(v);
    if (n === null) return v === null || v === undefined || v === '' ? '—' : v;
    return moneyFmt.format(n);
}

// Произвольная точность: fmtNum(96.84, 1) → 96,8
export function fmtNum(v, digits = 0) {
    const n = toNumber(v);
    if (n === null) return v === null || v === undefined || v === '' ? '—' : v;
    return n.toLocaleString('ru-RU', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function fmtPercent(v, digits = 1) {
    const s = fmtNum(v, digits);
    return s === '—' ? s : `${s}%`;
}

// Даты: всегда по-русски и без секунд — 01.11.2026 14:05. Раньше часть страниц брала формат
// браузера (на англ. системе «9/22/2026, 9:19:36 AM»), часть — русский с секундами.
const dateTimeFmt = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const dateFmt = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });

function toDate(v) {
    if (!v) return null;
    const d = v instanceof Date ? v : new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
}

const dateTimeSecFmt = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });

// { seconds: true } — для истории событий: статусы одного сообщения приходят с разницей в секунды
export function fmtDateTime(v, { seconds = false } = {}) {
    const d = toDate(v);
    return d ? (seconds ? dateTimeSecFmt : dateTimeFmt).format(d).replace(',', '') : '—';
}

export function fmtDate(v) {
    const d = toDate(v);
    return d ? dateFmt.format(d) : '—';
}

// Сегодняшняя дата для <input type="date"> по местному времени. toISOString() даёт дату по UTC,
// и в Бишкеке (UTC+6) с полуночи до 6 утра фильтры по умолчанию показывали вчерашний день.
export function localISODate(d = new Date()) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Длинные идентификаторы (имена шаблонов, id) переносим по «_», «-», «.», «/» —
// невидимый пробел нулевой ширины после разделителя, а не обрез посреди слова
export function breakable(v) {
    return typeof v === 'string' ? v.replace(/([_\-./])/g, '$1​') : v;
}
